import { IntlShape } from "react-intl";
import { message, notification } from "antd";
import { getI18n } from "../../../../utils/Utils";

function resolveStatusCode(error: any): number | undefined {
    return error?.networkError?.statusCode || error?.networkError?.status || error?.statusCode || error?.status;
}

export function isUnauthorizedOrForbiddenError(error: any): boolean {
    const statusCode = resolveStatusCode(error);
    const messageText = String(error?.message || error?.networkError?.message || "");

    return statusCode === 401 || statusCode === 403 || messageText.includes("401") || messageText.includes("403");
}

export function notifyFreightAuthOrGenericError(options: {
    error: unknown;
    intl: IntlShape;
    unauthorizedMessage: { id: string; defaultMessage: string };
    genericMessage: { id: string; defaultMessage: string };
    useToast?: "message" | "notification";
}): void {
    const {
        error,
        intl,
        unauthorizedMessage,
        genericMessage,
        useToast = "notification",
    } = options;

    const text = isUnauthorizedOrForbiddenError(error)
        ? getI18n(unauthorizedMessage.id, unauthorizedMessage.defaultMessage, intl)
        : getI18n(genericMessage.id, genericMessage.defaultMessage, intl);

    if (useToast === "message") {
        message.error(text);
        return;
    }

    notification.error({ message: text });
}
